export default "__VITE_ASSET__a5dea811__"